import { Column, TableapiApi } from '@datum-group/isogd-openapi/lib';
import {
  action,
  computed,
  makeObservable,
  observable,
  runInAction,
} from 'mobx';

export class TableColumn {
  @observable private _columns: Column[] = [];
  @observable private _tableName: string;
  @observable private _isLoading = false;
  @observable private _error?: string = undefined;
  private _tableApi: TableapiApi;

  constructor(tableName: string, tableApi: TableapiApi) {
    this._tableApi = tableApi;
    this._tableName = tableName;
    makeObservable(this);
  }

  @computed get tableName() {
    return this._tableName;
  }

  @computed get isLoading() {
    return this._isLoading;
  }

  @computed get error() {
    return this._error;
  }

  @computed get columns() {
    return this._columns.map((e) => this._clone(e));
  }

  *getColumnIterator() {
    for (let column of this._columns) {
      yield this._clone(column);
    }
  }

  @action load = async () => {
    this._isLoading = true;
    this._error = undefined;

    try {
      const query = this._buildParams();
      const resp = await this._tableApi.apiColumnsList(1, 0, { query });
      runInAction(() => (this._columns = resp.data.results));
    } catch (e) {
      runInAction(
        () =>
          (this._error = `Не удалось загрузить колонки для таблицы с именем ${this._tableName}`),
      );
    } finally {
      runInAction(() => (this._isLoading = false));
    }
  };

  private _buildParams() {
    return {
      table_name: this._tableName,
    };
  }

  // FIXME: Костыль от бесконечного рендера
  private _clone(column: Column): Column {
    return { ...column };
  }
}
